import { useQuery } from "@tanstack/react-query";
import type {
  AdminAreaSuggestionView,
  AreaSuggestionStatus,
} from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useAreaSuggestionsQuery(status?: AreaSuggestionStatus) {
  const query = useQuery({
    queryKey: queryKeys.admin.areaSuggestions({ status }),
    queryFn: () => {
      const path = status
        ? `${endpoints.admin.areaSuggestions}?status=${encodeURIComponent(status)}`
        : endpoints.admin.areaSuggestions;
      return apiJsonClient<AdminAreaSuggestionView[]>(path);
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
